// constants and class definitions
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import * as createjs from "createjs-module";
import {STATE_NORMAL, STATE_FILE_IMPORT, STATE_OPEN_FILE,STATE_INIT,STATE_IN_ABC,STATE_IN_IPAD_ABC,
  STATE_IN_GRID_FRACTION_NUM, STATE_IN_GRID_FRACTION_DEN,
  STATE_IN_DRAG, STATE_DRAW_OVERLAY, STATE_IN_PROB_SCALE, STATE_IN_CLIPBOARD_SELECT,SymbolType,SymbolLong,SymbolSimple,
  OVERLAY_TYPE_LINE,OVERLAY_TYPE_DIVIDE,STATE_CARRY_SYM, SelectionAreaType, STATE_CLIPBOARD_SELECT_ICON,
  STATE_VIEW_ONLY_FILE} from 'src/assets/js/cv-classes.js';
import  { SIZE,CV_BACKGROUND_COLOR, DISPLAY_TYPE_GRID,DISPLAY_TYPE_LINE, FULL_CANVAS, SCALE_DOT_SIZE,
  SCALE_BOX_COLOR,PROBLEM_BACKGROUND_COLOR,PROBLEM_GRID_COLOR,STAGE_BACKGROUND_COLOR,
  CURSOR_COLOR,LINE_COLOR,LINE_DOT_SIZE,CREATEJS_NAME_LINE_DOT_START,CREATEJS_NAME_CARRY_TEXT,
 CanvasInput,CREATEJS_NAME_LINE_DOT,CREATEJS_NAME_CARRY_BOX,CREATEJS_NAME_LINE,
  DISPLAY_TYPE_TEXT,CREATEJS_NAME_DIVIDE,ONE_PAGE_WIDTH,ABC_BOX_INACTICE_COLOR, ABC_BOX_ACTIVE_STROKE,
  ABC_BOX_INACTIVE_STROKE,START_LINESEG_DOT,END_LINESEG_DOT} from 'src/app/shared/constant/drawConstants';

// routines and variables called from other files
import {clearProbState, db,stage,checkPosForPageAdd,cvGetDataUndoPush,doClipboardCopy,notifySideboardLev3Mode} from 'src/assets/js/draw.js';
import {setInsertOutsideGrid,pushOneNullSym, trimGrid} from 'src/assets/js/cv-grid-entry.js';
import {findProbEndX,findProbEndY,findProbSymX,findProbLineY,findBranchSymStartX,
        deleteEmptyProb,getCorrectXY,findBranchClickIndex,tallyLineSymWidths, 
        resetTreeXYPosAndCursor,calcSymOffsets,doStageUpdate,findLineSegDotIndex,getFillColor,
        findBranchClickIndexRightAdjusted,isClickNearSelectBoxFromMenu,findClickedLine} from 'src/assets/js/cv-helpers.js';
import {startMProb} from 'src/assets/js/cv-layout-shared.js';
import {drawOneABCBox} from 'src/assets/js/cv-text.js';
import {drawFractionRootLine} from 'src/assets/js/cv-line-entry.js';


let mouseCounter = 0;  // for testing

export function ifIpadAddStageContainer() {
  if (db.inIpad) {
    if (db.stageDragContainer != null) {
      stage.removeChild(db.stageDragContainer);
    }
    db.stageDragContainer = new createjs.Container();
    stage.addChildAt(db.stageDragContainer,0);
  }
}

// Add a background rectangle to the stage covering the whole stage, in a slight off-white color
// This color is desirable for the design, but also is needed 
// because stage doesn't support detecting "click" events except on top of a defined 
// createjs object or hit-test area.  It would be possible to use 'stagemousedown" instead but less convenient 
export function setStageBackground() {
    
    if (db.stageBackground != null) {
      db.stageBackground.removeAllEventListeners();
      stage.removeChild(db.stageBackground); 
    }
  
    let stageBackground = new createjs.Shape();
    let backgroundColor = (db.userPrefs != undefined) ? db.userPrefs.backgroundColor: CV_BACKGROUND_COLOR;
    
    if (db.inIpad) {
      stageBackground.graphics.beginFill(backgroundColor);  //CV_BACKGROUND_COLOR);
    }
    else {
      stageBackground.graphics.beginFill(backgroundColor);
      //stageBackground.alpha = .1; 
    }
    stageBackground.graphics.rect(0,0,stage.canvas.width/stage.scaleX,stage.canvas.height/stage.scaleY);     
    stageBackground.x = 0;
    stageBackground.y = 0;
    stageBackground.name = FULL_CANVAS;
    db.stageBackground = stageBackground;
    // if on an ipad, then put everything drawn including the background into the
    // stage drag container, to be able to drag to simulate scroll bars
    // plus put a dark rectangle that doesn't move behind this to provide user
    // feedback
    if (db.inIpad) {
      db.stageDragContainer.addChildAt(db.stageBackground,0);
      let darkBackground = new createjs.Shape();
      darkBackground.graphics.beginFill("gray");
      darkBackground.graphics.rect(0,0,stage.canvas.width/stage.scaleX,stage.canvas.height/stage.scaleY);     
      darkBackground.x = 0;
      darkBackground.y = 0;
      // put the grey backer background in the very back, after
      // adding the drag container
      stage.addChildAt(darkBackground,0);
    }
    else {
      stage.addChildAt(stageBackground,0);
    }
    
    stage.update();
  }



// Process a new mouse click in an empty area of the stage
// create and set up a new math problem (not implemented) and change x,y coordinats
export function handleStageMouse() {
  

  //stage.enableMouseOver(40);  

  db.stageBackground.addEventListener("mousedown", function (e) {
    //console.log("stage mousepress");

    // throw out mouse clicks in view only files except for in iPad to watch for scrolls
    if (db.state == STATE_VIEW_ONLY_FILE && !db.inIpad) {
      return;
    }
   
    let point;
    // ignore stage clicks in the very top of the window, to prevent problems going off the top edge
    // or missed menu clicks causing issues
    if (stage.mouseY > 30) {
  
      if (db.state == STATE_INIT) {
        db.state = STATE_NORMAL;
      }

      if (db.state == STATE_IN_CLIPBOARD_SELECT)  {
        // call clear state with flags set to only clear clipboard
        clearProbState(false,true);
      }
      
      if (db.probState == STATE_IN_IPAD_ABC) {
        clearProbState();
      }

      let dragged = false;

 
      // throw out mouse events that bubbled from containers and didn't get stopped
      // only accept events that the primary target is the stage background, stage, or image file
      // based on name FULL_CANVAS having been stored in these createjs objects
      // plus ignore bubbled events during a file import
      if (db.state != STATE_FILE_IMPORT  && e.target.name == FULL_CANVAS && db.state != STATE_IN_ABC) {
        
        //alert("in stage press");
        db.changed = true;
        
        if (db.inIpad) {
          let startX =  stage.mouseX/stage.scaleX;      //stage.mouseX/stage.scaleX;
          let startY = stage.mouseY/stage.scaleX;
          let startBackX = db.stageDragContainer.x;
          let startBackY = db.stageDragContainer.y;
          let newX = 0;
          let newY = 0;
          db.stageBackground.addEventListener('pressmove',function (e) {
           
            newX = stage.mouseX/stage.scaleX- startX; // + startBackX;
            newY = stage.mouseY/stage.scaleX - startY; // + startBackY;
         
    
              db.stageDragContainer.x = newX + startBackX; // + startBackX;
              db.stageDragContainer.y = newY + startBackY; 
            //}
            if (newX != 0) {
              dragged = true;
            }
            stage.update();
          });
        }
        
        stage.update();
        db.stageBackground.addEventListener('pressup',function(e) {
          //console.log("stage mouseup");
          db.stageBackground.removeAllEventListeners('pressmove');
          db.stageBackground.removeAllEventListeners('pressup');
         
          //console.log("press up");
          if (!dragged  && db.state != STATE_VIEW_ONLY_FILE) {
          
             // clearn up the prior grid problem
             if (db.curProb != null && db.curProb.displayType == DISPLAY_TYPE_GRID) {
              clearLineSegDots();
              trimGrid();
            }

            // process the pressup as a stage click, and create a new problem
            // mouse coordinates don't scale with the stage automatically so have to fix that
            point = getCorrectXY();
            // mouse coordinates don't scale with the stage automatically so have to fix that
            db.xpos = point.x;
            db.ypos = point.y;
            //alert(stage.mouseX);


            // if they clicked near the end of the canvas, then add another page
            checkPosForPageAdd();
            startMProb(db.displayType); 

            // MOVED THIS FROM HIGHER for overlays,TEST IT
            if (db.probState != STATE_NORMAL) {
              clearProbState();
            }
        
            let logInput = new CanvasInput("stage click ","X" + db.xpos + " Y" + db.ypos);
            db.userLog.input.push(logInput);
          }
         
        });
                
      }
    }
  });
  
}


// change the grid of a problem to being not visible to hide it
export function hideGridShape(mProb) {

  if (mProb.gridShape != null) {
    mProb.gridShape.visible = false;
    doStageUpdate();
  }
  if (mProb.gridSurroundBox != null) {
    if (mProb.displayType == DISPLAY_TYPE_GRID) {
      resetOverlayDisplay(mProb,false); 

      mProb.gridSurroundBox.visible = false;
      mProb.gridSurroundBox.off("click", handleGridSurroundClick);
    }
  }
 
  for (let i = 0; i < mProb.textSymList.length; i++) {
    let textSym = mProb.textSymList[i];
    if (textSym.box != null) {
      textSym.box.visible = false;
    }
  }
} 
  


// change the grid of a problem to visible to show it
export function showGridShape(mProb) {
  
  // show any abc text boxes
  for (let i = 0; i < mProb.textSymList.length; i++) {
    let textSym = mProb.textSymList[i];
    if (textSym.box != null) {
      textSym.box.visible = true;
    }
    else {
      let box = drawOneABCBox(textSym.container,textSym.w,textSym.h,"grey", ABC_BOX_ACTIVE_STROKE,"",0);
      textSym.box = box;
    }
  }
  if (mProb.displayType == DISPLAY_TYPE_GRID || mProb.displayType == DISPLAY_TYPE_LINE) {
    // display the grid
    if (!db.userPrefs.hideDisplayGrid) {
      if (mProb.gridShape != null) {
        mProb.gridShape.visible = true;
        //console.log("showGridshape make visiable");
      }
      else {
        // for line types, receive in null parameters and calculate sizes here
        if (mProb.displayType == DISPLAY_TYPE_LINE) {
          let height = mProb.heightBelow+mProb.heightAbove;
          let heightCount = height/mProb.gridH; //+.3;
          let heightOffset = (mProb.heightAbove == 0) ? 0 : -mProb.heightAbove/mProb.gridH;
          //console.log("from showGridShape", mProb.width);
          // add one to problem width to make box wider by one space to allow clicking to right of problem
          drawEmptyGrid(0,0,mProb.width+1,heightCount,heightOffset);
        }
        else {
          drawEmptyGrid(0,0,mProb.width,mProb.line.length);
        }
      }
    }
    // make active the surround box
    if (mProb.displayType == DISPLAY_TYPE_GRID) {
      resetOverlayDisplay(mProb,true); 

      if (mProb.gridSurroundBox != null) {
      mProb.gridSurroundBox.visible = true;
        mProb.gridSurroundBox.on("click", handleGridSurroundClick);
      }
      else {
        drawGridSurroundBox(mProb.width, mProb.line.length);
      }
    }
  }
  else {// text type box
    mProb.gridSurroundBox.visible = true;

  }
  doStageUpdate();
}

// Draw the shapes associated with a problem
// This is called each time a problem has symbols added to it so therefore changes size
export function drawProbShapes(widthCount,heightCount,redrawMainBranch) {
 
  let heightOffset, height;

  // for line types, receive in null parameters and calculate sizes here
  if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
    height = db.curProb.heightBelow+db.curProb.heightAbove;
    heightCount = height/db.curProb.gridH; //+.3;
    heightOffset = (db.curProb.heightAbove == 0) ? 0 : -db.curProb.heightAbove/db.curProb.gridH;
    widthCount = db.curProb.width+1;  // add one space after line problems to allow clicking after problem
    //console.log("in drawProbShapes", widthCount);

  }

  // for view-only due to unmatching level, don't draw any of the boxes if matchLevel = false;
  if (db.curProb.matchLevel) {

    // set up the background box since mouse presses only detected on visable object
    // As long as the user doesn't have hide grids selected, if this is a grid-type problem
    // then draw a grid shape.  Remove any prior one if needed
    if (db.state != STATE_OPEN_FILE) {
      if (db.curProb.displayType == DISPLAY_TYPE_GRID || db.curProb.displayType == DISPLAY_TYPE_LINE)  {     
        if (db.curProb.gridShape != null) {
          db.curContainer.removeChild(db.curProb.gridShape);   // delete prior grid shape if there is one
        }
        if (!db.userPrefs.hideDisplayGrid) {      
          drawEmptyGrid(0,0,widthCount,heightCount,heightOffset);
        }
      }
    }

    switch (db.curProb.displayType) {
      case DISPLAY_TYPE_GRID:
        drawBackgroundBox(widthCount*db.curProb.gridW,heightCount*db.curProb.gridH);
        drawGridSurroundBox(widthCount,heightCount);
        break;
      case DISPLAY_TYPE_LINE:
        if (redrawMainBranch) {
          drawBranchBackground(db.curLine);
          if (db.curBranch.parent != null && db.curBranch.parent.isBranch) {
            drawBranchBackground(db.curBranch.parent);
          }
        }
        drawBranchBackground(db.curBranch);
        drawBackgroundBox(widthCount*db.curProb.gridW,heightCount*db.curProb.gridH,heightOffset);
        drawGridSurroundBox(widthCount,heightCount,false,heightOffset);
        break;
      case DISPLAY_TYPE_TEXT:
        let newW = db.curLine.sym[0].w/db.curProb.gridW;
        let newH = db.curLine.sym[0].h/db.curProb.gridH;
        drawBackgroundBox(db.curLine.sym[0].w, db.curLine.sym[0].h);
        drawGridSurroundBox(newW,newH,true);
        break;
      default:
        break;
    }
    
    if (db.state != STATE_VIEW_ONLY_FILE && !db.inOpenViewOnly) {
      watchMouseEvents(db.curProb.backgroundBox);
    }
   
    // create the mouse event listeners for this problem and manage them.  
   // This sets up for drag and drop, clicking problems, and long clicking to create scaling box
 
    doStageUpdate();
  }
  //else {
  //  console.log("no match in drawProbShapes", db.pIndex);
 // }
  
}


// function makeProbSelected is called when a user clicks on a problem
// that is not current, to make it the selected problem.   Line problems call makeProbSelectedAt instead except
// for after open files, as this just sets position to withitn line not branch
export function makeProbSelected(pIndex, lineIndex) { 
  //console.log("make prob selected", pIndex);

  
 // if (db.curOverlay != null && db.curOverlay.myProb != pIndex) {
  //  drawUpdatedOverlay(db.curOverlay,false);  // redraws the divide overlay unselected
  //  db.probState = STATE_NORMAL;
  //}
  //resetOverlayDisplay(false);
  
  if (pIndex >= 0) {
   
    db.pIndex = pIndex;
    db.curProb = db.mProb[pIndex];
    if (db.curProb.displayType == DISPLAY_TYPE_LINE || db.curProb.displayType == DISPLAY_TYPE_GRID) {
      db.displayType = db.curProb.displayType;
    }
    db.curContainer = db.curProb.container;
    // If lineIndex passed use that, otherwise set to last line of problem
    if (db.curProb.displayType == DISPLAY_TYPE_LINE && lineIndex != undefined) {
      db.curProb.lIndex = lineIndex;
    }
    else {
      db.curProb.lIndex = db.curProb.line.length-1;
    }
    
    db.curLine = db.curProb.line[db.curProb.lIndex];
    db.curLine.sIndex = db.curLine.sym.length-1;

    // go through the list of overlays, and make last div problem and lines active with drag lines, needed for undo
    //resetOverlayDisplay(true); 

    if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      db.curBranch = db.curLine;
      resetTreeXYPosAndCursor();
       }

    else if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    
      let endX = findProbEndX(db.curProb);
      let endY = findProbEndY(db.curProb);
      db.xpos = db.curProb.xpos + endX;
      db.ypos = db.curProb.ypos + endY;
      restartLineSegDots();

      
    }
    else  {  // DISPLAY_TYPE_TEXT
      db.xpos = db.curProb.xpos;
      db.ypos = db.curProb.ypos;
    }

  
    // this will make active the diplay of both grid and abc text boxes
    showGridShape(db.curProb);

    doStageUpdate();
  }
}

/**
 * function resetOverlayDisplay will make all the line overlays and the last division overlay in the db.curProb active will draggable
 * lengths or not active drawn in black - only does anything on grid problems as line problems don't use overlays
 */
function resetOverlayDisplay(mProb, active) { 

  if (mProb.displayType == DISPLAY_TYPE_GRID) {

    let tempLine = db.curLine;
    let nextOverlay;
  

    for (let j = 0; j <= mProb.line.length-1 ; j++) {

      if (mProb.line[j].overlayDiv.length > 0) {
        nextOverlay = mProb.line[j].overlayDiv[mProb.line[j].overlayDiv.length-1];
        nextOverlay.isActive = true;
        db.curLine = mProb.line[j];
        db.curOverlay = nextOverlay;
      
        drawUpdatedOverlay(nextOverlay,active);

      }

      if (mProb.line[j].overlayLine != null) {
        nextOverlay = mProb.line[j].overlayLine
        nextOverlay.isActive = true;
        db.curLine = mProb.line[j];
        drawUpdatedOverlay(nextOverlay,active);
      
      }
    }
    db.curLine = tempLine;
  }

}

// function makeProbSelected is called when a user clicks on a problem
// that is not current, to make it the selected problem

export function makeProbSelectedAt(pIndex,lIndex,sIndex) { 
  //console.log("make prob selected AT", pIndex,lIndex,sIndex);


  //resetOverlayDisplay(false);

  if (pIndex >= 0 && pIndex < db.mProb.length) {
    db.pIndex = pIndex;
    db.curProb = db.mProb[pIndex];
    db.curContainer = db.curProb.container;

   // resetOverlayDisplay(true);
    db.curProb.lIndex = lIndex;
    db.curLine = db.curProb.line[db.curProb.lIndex];
    
    if (db.curProb.displayType == DISPLAY_TYPE_GRID || db.curProb.displayType == DISPLAY_TYPE_TEXT) {

     
      db.curLine.sIndex = sIndex
      let endX = findProbSymX(db.curProb);
      let endY = findProbLineY(db.curProb);

      db.xpos = db.curProb.xpos + endX;
      db.ypos = db.curProb.ypos + endY;

      // this will make active the diplay of both grid and abc text boxes
      showGridShape(db.curProb);
      drawCursor(db.xpos - db.curProb.halfGW, db.ypos-db.curProb.halfGH);
    }
    else { // DISPLAY_TYPE_LINE
      
      resetTreeXYPosAndCursor();
      showGridShape(db.curProb);

    }
   
    doStageUpdate();
  }
  else {
    console.log("invalid pIndex at makeprobselectedat", pIndex, db);
  }
}


//  function drawBackgroundBox draws a createjs rectangle to serve as the background to a problem
// for the purpose of detecting mouse presses 
function drawBranchBackground(branch) {
  

    if (branch.branchBackground != null) {
      branch.container.removeChild(branch.branchBackground);
    }  
    branch.branchBackground= new createjs.Shape();          // make a box around the symbol
    branch.branchBackground.name = db.pIndex;                // save problem index so can refer back to this problem
    branch.branchBackground.branch = branch;          // save current branch location too for event handler
    branch.branchBackground.alpha = 0.01;
    branch.container.addChildAt(branch.branchBackground,0);   // put background box at index 0 to be in back
    branch.branchBackground.graphics.beginFill(CV_BACKGROUND_COLOR); //PROBLEM_BACKGROUND_COLOR);  
    branch.branchBackground.graphics.rect(0,0,branch.lineWidth*db.curProb.gridW, //branch.bScale in lineWidth
         db.curProb.gridH*branch.lineHeight);   //FIX
    
    branch.branchBackground.x = 0;
    branch.branchBackground.y = 0;
    branch.branchBackground.isBranch = true;
    branch.branchBackground.branchID = branch.branchID;
    //branch.branchBackground.addEventListener('click',watchMouseClick);   
    doStageUpdate();
    
    if (!db.inOpenViewOnly)  {
      watchMouseEvents(branch.branchBackground);
    }
    

  }



/**
 * function drawSelectionHighlight draws the selection box used for internal clipboard
 * copy/paste.  It is constrained to just be on the same line as the starting position/symbol
 * It is called by the mouse handler for each move event of drawing the selection box
 */
function drawselectionHighlight(selectionArea) {
  //alert("here");
  
  let width, height;
  // have to redraw seletion box each time, cause that's how createjs is
  if (selectionArea.box != null) {
    selectionArea.parent.removeChild(selectionArea.box);
  }  

  // create selection box createjs object
  selectionArea.box = new createjs.Shape();       // make a box around the symbol
  selectionArea.name = db.pIndex;                // save problem index so can refer back to this problem
  selectionArea.box.alpha = 0.3;
  //selectionArea.box.cursor = 'copy'; // 'ew-resize'
  
  // for grid problems, always height of row, and user can select before or after cursor
  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    // constrain the selection box to be only within the width of the problem, and at least one character wide
    if (selectionArea.width >= 0) { 
      width = (selectionArea.width > selectionArea.beginWidth) ? 
                Math.min(selectionArea.width, selectionArea.probEndX) : selectionArea.beginWidth;
    }
    else {
      // since dealing with negative numbers here, need to reverse the usage of max and min to figure out width, 
      // plus the start becomes the right edge of the starting rectangle
      width = Math.max(Math.min(selectionArea.width,-selectionArea.beginWidth),selectionArea.probStartX) + selectionArea.beginWidth;
    }
  }

  // For line problems, lots of calculations needed to get branch positions right
  else if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
    // can only select to the right of original click for lines
    if (selectionArea.width >= 0) {

      if (selectionArea.inBranch) {
        // if within branch but user didn't start with first symbol, constrain box to be limited to branch width
        if (!selectionArea.hasFirstSym) {
          width = Math.min(selectionArea.width, selectionArea.endBranch);
        }

        // if within branch starting from first symbol, 
        // check if drag is wider than branch, if not just select within branch
        else {
          if (selectionArea.width <= selectionArea.endBranch) {
            width = selectionArea.width;
          }

         // Otherwise, process switching the current selectionArea branch to the parent of the current branch
          else {
            // in case this is a two branch symbol, set all the symbols in this branch to selected for the clip
            // pass it the parent branch symbol, with true to set it on 
            setClipFlags(selectionArea.curBranch.parent.sym[selectionArea.curBranch.parentIndex], true);
            // if is is wider than branch, then switch the allow the parent and set flag
            let temp = selectionArea.curBranch.parentIndex;
            //selectionArea.offset = -selectionArea.width;
            //selectionArea.curBranch.parent.container.x - selectionArea.curBranch.container.x;
            selectionArea.curBranch = selectionArea.startBranch.parent;
            
            db.curBranch = selectionArea.curBranch;
            db.curBranch.sIndex = temp-1;
            //move the cursor to the parent branch branching symbol position
            resetTreeXYPosAndCursor();
            selectionArea.beginHeight /= db.curBranch.bScale;
            selectionArea.inBranch = false;
            width = selectionArea.width; // + selectionArea.offset;  // offset will be negative
          }
        }
      }
      else {
        // if not in branch, then check if started in branch and changed to smaller size
        // if did, then switch the selection area current branch back to the original starting branch
        if ((selectionArea.wasBranch) && (selectionArea.width < db.selectionArea.endBranch)) {
            selectionArea.curBranch = selectionArea.startBranch;
            selectionArea.beginHeight *= db.curBranch.bScale;
            selectionArea.inBranch = true;
            db.curBranch = selectionArea.startBranch;
            resetTreeXYPosAndCursor();
            // reset to not selected the whole branch, to deal with two branch symbols
            // symbols in this branch will then get set back to selected at end of routine
            //console.log("Moved smaller");
            if (db.curBranch.parent.sym != null && db.curBranch.parent.sym[db.curBranch.parentIndex].str == 
              symConst.KEY_ID_FRACTION) {
            setSymColor(db.curBranch.parent.sym[db.curBranch.parentIndex], db.curBranch.parent,"black", false)
            db.curBranch.parent.sym[db.curBranch.parentIndex].isSelected = false;
            }
            setClipFlags(db.curBranch.parent.sym[db.curBranch.parentIndex], false);
        }
        // either way the width is the amount dragged 
        width = Math.min(selectionArea.width,selectionArea.probEndX); // + selectionArea.offset;
        
      }
    }
    else {
      selectionArea.width = 0;
      width = 0; 
    }
  }
  else {
    width = selectionArea.width;
  
  }
  // setup the endX since that what the copy routine uses
  db.selectionArea.endX = db.selectionArea.startX + width;
    
  // set up the createjs selection box other fields to draw the filled box
  // this always stays under the same parent even if the branch changes
  selectionArea.box.graphics.beginStroke("blue").setStrokeStyle(0.5); 
  selectionArea.box.graphics.beginFill("#fdfd96");  // pastel yellow
  selectionArea.box.graphics.rect(0,0,width, selectionArea.beginHeight);  
  selectionArea.box.x = selectionArea.startX;
  selectionArea.box.y = selectionArea.startY;
  selectionArea.box.mouseEnabled = false;
  selectionArea.parent.addChild(selectionArea.box);   // put background box at index 0 to be in back
 
  // Once done calculating the width to use for selection, then flag and color the symbols highlighted 
  // check each symbol in the current selection branch (done this way because easier than tracking which to check)
  for (let i = 0; i <= selectionArea.curBranch.sym.length-1; i++ ) {
   
    // compare the end of selection area, given by selectionArea.width, to the pre-calculated offset that indicates the start
    // of this symbol, compared to the starting position of selection.  Adjust to not select symbols until 1/3 across 
    // the symbol, so that symbols don't get selected just from white space
    if (selectionArea.curBranch.sym[i].clipOffset + selectionArea.curBranch.sym[i].width*.3*db.curProb.gridW < selectionArea.width 
          && selectionArea.curBranch.sym[i].clipOffset >= 0) {
     
      if (selectionArea.curBranch.sym[i].displayText != null) {
        if (selectionArea.curBranch.sym[i].displayText.color != "orange") {

        selectionArea.curBranch.sym[i].displayText.saveColor = selectionArea.curBranch.sym[i].displayText.color;
        
        //selectionArea.curBranch.sym[i].displayText.color = "orange"; //"#006400";  // dark green
        setSymColor(selectionArea.curBranch.sym[i],selectionArea.curBranch,"orange",true);
        }
      }
      // for the first time branch symbols are selected, then set to selected, and also
      // if branching symbol, then set the whole branch to selected
      if (!selectionArea.curBranch.sym[i].isSelected) {
        selectionArea.curBranch.sym[i].isSelected = true; 
        
        if (selectionArea.curBranch.sym[i].groupCode == symConst.CV_BRANCHING_GRP) {
          setClipFlags(selectionArea.curBranch.sym[i],true);
        }
      }
    }
    // if symbol isn't in selected area, then set it not selected.  This clears symbols in case of user
    // moving mouse backwards and shrinking selection area (also marks symbols never selected, done this way cause easier)
    else {
      
      if (selectionArea.curBranch.sym[i].isSelected) {
       
        
        if (selectionArea.curBranch.sym[i].displayText != null) {
         //selectionArea.curBranch.sym[i].displayText.color = "black";
        
         setSymColor(selectionArea.curBranch.sym[i],selectionArea.curBranch,selectionArea.curBranch.sym[i].displayText.saveColor,false);
        } 
        if (selectionArea.curBranch.sym[i].groupCode == symConst.CV_BRANCHING_GRP) {
          setClipFlags(selectionArea.curBranch.sym[i],false);
        }
        selectionArea.curBranch.sym[i].isSelected = false;
      }
    }
    
  }
  // if this is from menu icon select, then also move the resize dot
  if (db.selectionArea.resizeDot != null) {
    db.selectionArea.resizeDot.x = Math.max(db.selectionArea.startX + width, db.selectionArea.startX);
    db.selectionArea.resizeDot.y = db.selectionArea.startY + db.selectionArea.beginHeight*.5;
  }
  doStageUpdate();
}  

/**
 * recursive routine!
 * 
 * function setClipFlags is called during a clipboard select, to set the color and isSelected flags of branched
 * symbols nested within a selection area
 * sym passed is branching symbol defining the branches to set
 * addtoSelection - true means to set selected, false means to clear and set to black
 */
export function setClipFlags(sym, addToSelection,clearAll) {

  let branch;

  //if (sym.str == symConst.KEY_ID_FRACTION && !addToSelection) {
  //  setSymColor(sym, branch,"black", false);

  //}
 
  // check each branch for the branching symbol passed
  for (let i = 0; i <= sym.branchCount-1; i++) {
  
    branch = sym.branch[i];
    //for each symbol within each branch
    for (let j = 0; j <= branch.sym.length-1; j++) {
      
      // recurse if find any nested branches to set those inner branches
      if ( branch.sym[j].groupCode == symConst.CV_BRANCHING_GRP) {
        setClipFlags(branch.sym[j], addToSelection,clearAll);
      }
      // true addToSelection - so set fields to selected.  
      if (addToSelection) {
        // some symbols such as exponent branches could have null displayText, so skip those

        if (branch.sym[j].displayText != null && branch.sym[j].displayText.color != "orange") {  
          branch.sym[j].displayText.saveColor = branch.sym[j].displayText.color;
          setSymColor(branch.sym[j],branch,"orange",true);

        }
        branch.sym[j].isSelected = true;
      }
      // false addToSelection - clear those fields
      else {
        if (branch.sym[j].displayText != null) { 
          //branch.sym[j].displayText.color = "black";
          setSymColor(branch.sym[j],branch,branch.sym[j].displayText.saveColor,false);
        }
        branch.sym[j].isSelected = false;
        if (clearAll) {
          branch.sym[j].clipOffset = -1;
        }
      }
    }
  }

}


/**
 * Set the symbol to assigned color
 * function setSymColor checks if the symbol is a fraction or root sign, which will need redrawing of lines/root sign to change the color
 * or just a regular symbol which color change is by setting displayText.color
 */
export function setSymColor(sym, branch,color, makeSelected) {

  // check if there has been a change, and set colors if changed
  color = (color) ? color : "black";
  
  if (sym.isSelected != makeSelected) {
  
    if (sym.str == symConst.KEY_ID_FRACTION || sym.type == symConst.CV_DIV_SQRT_TYPE) {
      drawFractionRootLine(sym,branch,color);
    }
    else {
      sym.displayText.color = color;
    }
    if (sym.fractionNum != null) {
      sym.fractionNum.color = color;
    }
    if (sym.fractionDen != null) {
      sym.fractionDen.color = color;
    }
    // check for and highligh cross-off digits
    if (sym.crossOff != null && (sym.crossOffType == symConst.KEY_ID_CROSSOFF_2 ||
                                sym.crossOffType == symConst.KEY_ID_CROSSOFF_3)) {
   
        let carryText = sym.crossOff.getChildByName(CREATEJS_NAME_CARRY_TEXT);
        
          if (carryText != null) {
            carryText.color = color;
          }
          //if (carryText.text[1] != null) {
          //  carryText.text[1].color = color;
          //}
            
      }
  }
}

//  function drawBackgroundBox draws a createjs rectangle to serve as the background to a problem
// for the purpose of detecting mouse presses 
function drawBackgroundBox(width,height,heightOffset) {
  //console.log(heightOffset);
  //console.log(widthCount,heightCount);
  
  if (db.curProb.backgroundBox != null) {
    db.curContainer.removeChild(db.curProb.backgroundBox);
  }
  db.curProb.backgroundBox = new createjs.Shape();          // make a box around the symbol
  db.curProb.backgroundBox.name = db.pIndex;                // save problem index so can refer back to this problem
 
  db.curContainer.addChildAt(db.curProb.backgroundBox,0);   // put background box at index 0 to be in back
  
  let color = getFillColor(db.curProb.backgroundBox);
  db.curProb.backgroundBox.graphics.beginFill(color); // CV_BACKGROUND_COLOR);  
  db.curProb.backgroundBox.graphics.rect(SCALE_DOT_SIZE,SCALE_DOT_SIZE,
        (width)-(2*SCALE_DOT_SIZE),height-(2*SCALE_DOT_SIZE));   
  
  db.curProb.backgroundBox.x = 0;
  db.curProb.backgroundBox.y = (heightOffset) ? heightOffset*db.curProb.gridH: 0;
  db.curProb.backgroundBox.isBranch = false;
  db.curProb.backgroundBox.branchID = -1; // identifies this from branch backgrounds
}

//  function drawBackgroundBox draws a createjs rectangle to serve as the background to a problem
// for the purpose of detecting mouse presses 
function drawGridSurroundBox(widthCount,heightCount, textType, heightOffset) {
  if (db.curProb.gridSurroundBox != null) {
    db.curContainer.removeChild(db.curProb.gridSurroundBox);
  }  
  db.curProb.gridSurroundBox = new createjs.Shape();          // make a box around the symbol
  db.curProb.gridSurroundBox.name = db.pIndex;                // save problem index so can refer back to this problem
  //db.curProb.gridSurroundBox.alpha = .5; //0.05;
  db.curProb.gridSurroundBox.x = 0;
  db.curProb.gridSurroundBox.y =   (heightOffset) ? heightOffset*db.curProb.gridH: 0;
  db.curProb.gridSurroundBox.name = db.pIndex;

  let color = getFillColor(db.curProb.gridSurroundBox);

  // add gridsurround box after background box to have it the furthest back
  db.curContainer.addChildAt(db.curProb.gridSurroundBox,0);  
  
  
  if (textType) {
    db.curProb.gridSurroundBox.graphics.beginFill(color); ///STAGE_BACKGROUND_COLOR);  
    //db.curProb.gridSurroundBox.graphics.rect(0,0,400,400);
    //db.curProb.gridSurroundBox.graphics.rect(-db.curProb.gridW2, -db.curProb.gridH,
    //      (db.curProb.gridW*(widthCount+2)),db.curProb.gridH*(heightCount+2));
    db.curProb.gridSurroundBox.graphics.rect(-5, -5,
      (db.curProb.gridW*widthCount)+10,db.curProb.gridH*heightCount+10); 

  }
  else if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    db.curProb.gridSurroundBox.graphics.beginFill(color); //CV_BACKGROUND_COLOR);  
    db.curProb.gridSurroundBox.graphics.rect(-db.curProb.gridW, -db.curProb.gridH,
          (db.curProb.gridW*(widthCount+2)),db.curProb.gridH*(heightCount+2)); 
    db.curProb.gridSurroundBox.addEventListener('click',handleGridSurroundClick);    
  }
  else {    // DISPLAY_TYPE_LINE, draw smaller surround box just to be able to ignore mouse clicks there
    db.curProb.gridSurroundBox.graphics.beginFill(color); //CV_BACKGROUND_COLOR); 
    db.curProb.gridSurroundBox.graphics.rect(-(db.curProb.gridW/2), -(db.curProb.gridH)/4,
          (db.curProb.gridW*(widthCount+1)),
          (db.curProb.gridH*heightCount+(db.curProb.gridH/2)));
    db.curProb.gridSurroundBox.addEventListener('click',handleGridSurroundClick);

  }
  
}

function handleGridSurroundClick(e) {
  

  // if it's a text problem do nothing, this handler just to avoid clicks creating new problems
  // to close to text
  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    if (db.probState != STATE_NORMAL && db.probState != STATE_IN_PROB_SCALE) {
      clearProbState();
    }
    
    if (db.state != STATE_IN_ABC  && db.probState != STATE_IN_PROB_SCALE) {
      // adjust the coordinates in case of problem scaling, since doing calucalations inside the problem
      //var point = db.curProb.container.globalToLocal(stage.mouseX, stage.mouseY); 
      var point = getCorrectXY(db.curProb.container);
      let newX = point.x + db.curProb.container.x;
      let newY = point.y + db.curProb.container.y;
      //console.log(newX,newY);
      setInsertOutsideGrid(newX,newY);
      
      //setInsertOutsideGrid(stage.mouseX/stage.scaleX, stage.mouseY/stage.scaleY);
    }
  }
  else {
  
    /*
    // if clicking on current problem then adjust cursor to end
    if (e.target.name == db.pIndex) {
      db.curLine.sIndex = db.curLine.sym.length-1;
      db.curBranch = db.curLine;
      resetTreeXYPosAndCursor()
    }
      */
  }
  
}
export function drawCrossOff(symObj,sIndex,lIndex,keyID) {

  let scale = 1;
  let extraScale = 1;
  let symW,symH;
  if (symObj.crossOff != null) {
    if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
      db.curProb.container.removeChild(symObj.crossOff);  //change for line
    }
    else {
      db.curBranch.container.removeChild(symObj.crossOff);  
    }
  }

  symObj.crossOff = new createjs.Container;
  symObj.crossOffType = keyID;

  if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
    scale = db.curBranch.bScale;
    symObj.crossOff.x =findBranchSymStartX(db.curBranch,db.curBranch.sIndex);
    symObj.crossOff.y = 0; //startY = 0;  //? offsets
    symW = db.curProb.gridW * symObj.width;
    symH = db.curProb.gridH * scale;

  }
  else {
    symObj.crossOff.x= sIndex*db.curProb.gridW;  // adjust position to be next to cursor
    symObj.crossOff.y = lIndex*db.curProb.gridH;
    symW = db.curProb.gridW;
    symH = db.curProb.gridH;  
  } 
  

  if (keyID != symConst.KEY_ID_CROSSOFF_3) {
    let crossOffLine = new createjs.Shape();
    crossOffLine.graphics.beginStroke("blue").setStrokeStyle(2*scale);
    crossOffLine.graphics.moveTo(symW*.75,symH*.25).lineTo(symW*.25,symH*.75);
    crossOffLine.x = crossOffLine.y = 0;
    symObj.crossOff.addChild(crossOffLine);
  }
  

  if (db.probState == STATE_CARRY_SYM) {
    // save this crossOff object to db only if there is a carryBox that will need removing
    db.curCrossOff = symObj.crossOff;

    // create a highlight box to show user that symbols will go in carry position
    let carryBox = new createjs.Shape();
    carryBox.name = CREATEJS_NAME_CARRY_BOX;
    carryBox.graphics.beginFill('yellow');  
    carryBox.alpha = 0.5;
    carryBox.graphics.rect(0,0,
      (symW*0.4),symH*0.25);  
    carryBox.x = carryBox.y = 0; 
    symObj.crossOff.addChild(carryBox);

  }
  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    db.curProb.container.addChild(symObj.crossOff); 
  }
  else {
    db.curBranch.container.addChild(symObj.crossOff); 
  }
  
  
  
  doStageUpdate();
}

export function hideCarryBox(crossOffObj) {
  let carryBox = crossOffObj.getChildByName(CREATEJS_NAME_CARRY_BOX);
  crossOffObj.removeChild(carryBox);
  doStageUpdate();

}

/* drawCursorAt just calls drawcursor with the current problems coordinates added
*/
export function drawCursorAt(startX,startY,scale) {
  startX += db.curProb.container.x;
  startY += db.curProb.container.y;
  drawCursor(startX,startY,scale);

}



 // function drawCursor will draw a highlighed shape as a cursor in the given position
  // in the size of the current problem grids
  export function drawCursor(startX,startY,scale) {

    // scale is passed in for branches on levels 3/4.  Set to 1 if not passed in for no scale
    scale = (scale) ? scale : 1; 
  
    if (db.cursor != null) {
      db.mProb[db.cursor.name].container.removeChild(db.cursor);
    }
    
    let color = symConst.CV_CURSOR_COLOR[db.userPrefs.cursorColorIndex];   //CURSOR_COLOR;
    let fracColor = "#ffff00"; //"#fbed5d";//"#fff45c";

    // if within a grid fraction, then draw an alternate grid fraction instead of usual cursor
    if (db.curProb != null &&
        db.curProb.displayType == DISPLAY_TYPE_GRID &&
        db.curProb.fracState != STATE_NORMAL) {

      db.cursor = new createjs.Shape();
      db.cursor.graphics.beginFill(fracColor);
      db.cursor.graphics.rect(0,0,db.curProb.gridW,db.curProb.gridH/2);
      db.cursor.x = startX-db.curContainer.x;
      db.cursor.y = startY-db.curContainer.y;
      db.cursor.alpha = .3;
      db.cursor.name = db.pIndex;         // store this here to be able to find cursor when need to remove it
      if (db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) {
        db.cursor.y += db.curProb.gridH/2;
      }
      db.curContainer.addChildAt(db.cursor,0);
    }
    else {

      // no or null parameters passed in means to hide the cursor
      if (startX != null && db.curProb != null &&
          db.curProb.displayType != DISPLAY_TYPE_TEXT) {

        db.cursor = new createjs.Shape();

        if (db.curProb.displayType == DISPLAY_TYPE_LINE && db.curBranch.isBranch) {
          color = symConst.CV_BRANCH_CURSOR_COLOR[db.curBranch.branchIndex][db.userPrefs.cursorColorIndex];
          scale = db.curBranch.bScale *.85;
          if (db.userPrefs.cursorColorIndex == 0 || db.userPrefs.cursorIndex == 3) {
          db.cursor.alpha = (db.curBranch.branchIndex == 0) ? 0.4 : 0.5;
          }

        }
        else {
          db.cursor.alpha = 0.8;
        }
          // Make cursor thinner for smaller font sizes but not to thin
          let sizeAdjust = (db.fontIndex < 9 ) ? Math.max((db.fontIndex)/8, .5) : 1;
          let strokeSize = 4/db.curProb.probScale * sizeAdjust;
          
          db.cursor.graphics.beginStroke(color).setStrokeStyle(strokeSize).moveTo(0,0);
          db.cursor.graphics.lineTo(0,db.curProb.gridH*scale).lineTo(db.curProb.gridW*scale,db.curProb.gridH*scale);
        
          if (db.curContainer != null) {
            if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
            
              db.cursor.x = startX-db.curContainer.x;///db.curBranch.container.x;
              db.cursor.y = startY-db.curContainer.y; //-db.curBranch.container.y;
            }
            else {
              db.cursor.x = startX-db.curContainer.x;
              db.cursor.y = startY-db.curContainer.y;
            }
          } 
          else {  // at empty problem just created by a stage click, so position is the same as starting position
            db.cursor.x = startX;
            db.cursor.y = startY;
          }
          db.cursor.name = db.pIndex;         // store this here to be able to find cursor when need to remove it
          
          db.curContainer.addChild(db.cursor);
        
        }
      }
        doStageUpdate();
  }

  // function drawCursor will draw a highlighed shape as a cursor in the given position
  // in the size of the current problem grids
  export function drawTreeCursor(startX,startY,scale) {

    // scale is passed in for branches on levels 3/4.  Set to 1 if not passed in for no scale
    scale = (scale) ? scale : 1; 
  
    if (db.cursor != null) {
      db.mProb[db.cursor.name].container.removeChild(db.cursor);
    }
  
    let blue = "#00417a";
    let teal = "#008897";
   
    let orange = "#ffaf54";
    let color = CURSOR_COLOR;
    let cursor;
   
   

    // no or null parameters passed in means to hide the cursor
    if (startX != null && db.curProb.displayType != DISPLAY_TYPE_TEXT) {

        cursor = new createjs.Shape();
      

      if (db.curProb.displayType == DISPLAY_TYPE_LINE && db.curBranch.isBranch) {
        color = (db.curBranch.branchIndex == 0) ? "teal" : "orange" ;
        scale = db.curBranch.bScale; // *.85;
         cursor.alpha = (db.curBranch.branchIndex == 0) ? 0.4 : 0.5;
      }
      else {
        cursor.alpha = 0.8;
      }
  
        cursor.graphics.beginStroke(color).setStrokeStyle(4).moveTo(0,0);
        cursor.graphics.lineTo(0,db.curProb.gridH*scale).lineTo(db.curProb.gridW*scale,db.curProb.gridH*scale);
       
        if (db.curContainer != null) {
          if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
          
            cursor.x = startX;
            cursor.y = startY;
          }
          else {
            cursor.x = startX;
            cursor.y = startY;
          }
        } 
        else {  // at empty problem just created by a stage click, so position is the same as starting position
          cursor.x = startX;
          cursor.y = startY;
        }
        cursor.name = db.pIndex;         // store this here to be able to find cursor when need to remove it
        db.curProb.container.addChild(cursor);
       
      }
      db.cursor = cursor;
      doStageUpdate();
  }
  export function drawBranchCursor(cursor,startX,startY,color) {

    // scale is passed in for branches on levels 3/4.  Set to 1 if not passed in for no scale
    scale = (scale) ? scale : 1; 
  
    // set cursor name to mprob index it is within
    if (cursor != null) {
      db.mProb[db.cursor.name].container.removeChild(cursor);
    }

    // no or null parameters passed in means to hide the cursor
    if (startX != null) {

      cursor = new createjs.Shape();

        //cursor.graphics.beginStroke(CURSOR_COLOR).setStrokeStyle(5).moveTo(0,0);
        //cursor.graphics.lineTo(0,db.curProb.gridH*scale).lineTo(db.curProb.gridW*scale,db.curProb.gridH*scale);

        db.curBranch.branchBackground.graphics.beginFill(color);
    
        db.curBranch.branchBackground.graphics.rect(0,0,db.curProb.gridW*db.curBranch.bScale, //db.curBranch.bScale in lineWidth
         db.curProb.gridH*db.curBranch.bScale);   
      
        cursor.alpha = 0.5;
        if (db.curContainer != null) {
         
            db.cursor.x = startX-db.curContainer.x;///db.curBranch.container.x;
            db.cursor.y = startY-db.curContainer.y; //-db.curBranch.container.y;
          
        } 
       
        cursor.name = pIndex;         // store this here to be able to find cursor when need to remove it
        db.curContainer.addChild(cursor);
      }
      doStageUpdate();
  }

  export function drawPageBreakLine(ypos) {
   
    if (db.pageBreakContainer == null) {
      db.pageBreakContainer = new createjs.Container();
      stage.addChild(db.pageBreakContainer);
    }
    let pageBreakLineL = new createjs.Shape();
    pageBreakLineL.graphics.beginStroke("blue").setStrokeStyle(2);
    pageBreakLineL.graphics.moveTo(10,0).lineTo(60,0);
    pageBreakLineL.x = 0;
    pageBreakLineL.y = ypos-10;

    let pageBreakLineR = new createjs.Shape();
    pageBreakLineR.graphics.beginStroke("blue").setStrokeStyle(2);
    pageBreakLineR.graphics.moveTo(ONE_PAGE_WIDTH-60,0).lineTo(ONE_PAGE_WIDTH-10 ,0);
    pageBreakLineR.x = 0;
    pageBreakLineR.y = ypos-10;
    db.pageBreakContainer.addChild(pageBreakLineR,pageBreakLineL);
    doStageUpdate();
    
  }

  export function drawOneSetLineSegment(line,lineY,startIndex,endIndex,color) {

    //console.log("draw set", startIndex,endIndex);

    // add a line segment shape to the bottom of each symbol
    let segX = startIndex * db.curProb.gridW; 
    let gridWidth = db.curProb.gridW; 
   
    endIndex = Math.min(endIndex, line.sym.length-1);
    startIndex = Math.min(startIndex, line.sym.length-1);
    
    for (let i = startIndex; i <= endIndex; i++) {
      if (line.sym[i].lineSeg != null) {
        db.curProb.container.removeChild(line.sym[i].lineSeg);
      }
      line.sym[i].lineSeg = new createjs.Shape();
      line.sym[i].lineSeg.graphics.beginStroke(color).setStrokeStyle(2);
      line.sym[i].lineSeg.graphics.moveTo(segX,lineY).lineTo(segX+gridWidth,lineY);
      db.curProb.container.addChild(line.sym[i].lineSeg);

      segX +=gridWidth;
    }

  }

  export function makeNewLineSegment(line, lIndex,startIndex,endIndex) { //startX,endX,keyID,overlay) {

    let color = "black";

    // fill grids if needed, to avoid issues with writing lines over empty grid spaces
    if (line.sym.length < db.curProb.width) {
      let tempLine = db.curLine;
      db.curLine = line;
      for (let i = line.sym.length; i < db.curProb.width; i++) {
        pushOneNullSym();
      }
      db.curLine = tempLine;
    }

    //check for and fix up if this line length if shorter than problem length
    // add null symbols if needed
    // put in some safety checks on indexes, since bad indexes here cause hangs in createjs
    if (startIndex > line.sym.length-1) {
      startIndex = line.sym.length-1;
    }
    if (endIndex < startIndex) {
      endIndex = startIndex;
    }
    else if (endIndex > line.sym.length-1) {
      endIndex = line.sym.length-1;
    }
 
     // add a line segment shape to the bottom of each symbol
     let lineY = (lIndex+1) * db.curProb.gridH; 
     let gridWidth = db.curProb.gridW;
 
     startIndex = (startIndex == null) ? 0 : startIndex;
     endIndex = (endIndex == null) ? line.sym.length-1 : endIndex;

    // look to see if there is another line segment on line, and if so 
    // adjust the start position to be after that if the line starts at 0 
    // it could be that a line is flagged with hasLineSeg but doesn't have any, if the segs
    // have been deleted (not updated on delete) 
    if (line.hasLineSeg) {//] && startIndex == 0) {
      let findLastEnd = -1;
      for (let i = line.sym.length-1; i >= 0 && findLastEnd == -1 ; i--) {
        if (line.sym[i].lineSegEnd != null) {
          findLastEnd = i;
        }
      }
      
      if (findLastEnd != -1) {
        // set new line to 1 unit long, either at sIndex or at the end of line
        if (startIndex == line.sIndex+1) {
          endIndex = startIndex;
        }
        else {
          startIndex = endIndex; // (findLastEnd == line.sym.length-1) ? findLastEnd : findLastEnd + 1;
        }
      
      }
    }
  
    line.hasLineSeg =  true;
   

    drawOneSetLineSegment(line,lineY,startIndex,endIndex,color);
    
    let startDot = new createjs.Shape();
    startDot.name = CREATEJS_NAME_LINE_DOT_START;
    startDot.graphics.beginStroke(color).beginFill(db.userPrefs.backgroundColor).drawCircle(0,0,6/stage.scaleX);
    startDot.x = startIndex*db.curProb.gridW; 
    startDot.y = lineY;
    line.sym[startIndex].lineSegStart = startDot;

    let endDot = new createjs.Shape();
    //endDot.name = CREATEJS_NAME_LINE_DOT_END;
    endDot.graphics.beginStroke(color).beginFill(db.userPrefs.backgroundColor).drawCircle(0,0,6/stage.scaleX);
    endDot.x = (endIndex+1)*db.curProb.gridW; 
    endDot.y = lineY;
    line.sym[endIndex].lineSegEnd = endDot;
   

    db.curProb.container.addChild(startDot,endDot); 
    // add fields for the matching pair dot, to be used to detect line deletes 
    startDot.matchingDot = endDot;
    endDot.matchingDot = startDot;
   
    doStageUpdate();
    db.probState = STATE_DRAW_OVERLAY;
    
    if (db.state != STATE_OPEN_FILE) {
      watchLineSegResize(END_LINESEG_DOT,endDot,line,endIndex,color);
      watchLineSegResize(START_LINESEG_DOT,startDot,line,startIndex,color);
    }
    else {
      endDot.visible = false;
      startDot.visible = false;
    }
    
  }

 /**
   * functon restartLineSegDots is called when reactivating a problem
   * to turn the line segment event watchers back one
   */

export function restartLineSegDots() {

  let color = "black";

  for (let i = 0; i <= db.curProb.line.length-1; i++) {
    for (let j = 0; j <= db.curProb.line[i].sym.length-1; j++)  {
      if (db.curProb.line[i].sym[j].lineSegStart != null) {
        db.curProb.line[i].sym[j].lineSegStart.visible = true;
        watchLineSegResize(START_LINESEG_DOT,db.curProb.line[i].sym[j].lineSegStart,
                            db.curProb.line[i],j,color);
      }
      if (db.curProb.line[i].sym[j].lineSegEnd != null) {
        db.curProb.line[i].sym[j].lineSegEnd.visible = true;
        watchLineSegResize(END_LINESEG_DOT,db.curProb.line[i].sym[j].lineSegEnd,
                            db.curProb.line[i],j,color);
      }
    }
  }
}


  /**
   * functon restartLineSegDots is called when turn off event listeners
   * for line segment end dots
*/
export function clearLineSegDots() {
  //console.log("clear dots",db.curProb);

  for (let i = 0; i <= db.curProb.line.length-1; i++) {
    for (let j = 0; j <= db.curProb.line[i].sym.length-1; j++)  {
      if (db.curProb.line[i].sym[j].lineSegStart != null) {
        db.curProb.line[i].sym[j].lineSegStart.removeAllEventListeners();
        db.curProb.line[i].sym[j].lineSegStart.visible = false;

        
      }
      if (db.curProb.line[i].sym[j].lineSegEnd != null) {
        db.curProb.line[i].sym[j].lineSegEnd.removeAllEventListeners();
        db.curProb.line[i].sym[j].lineSegEnd.visible = false;
        
      }
    }
  }
}

  function watchLineSegResize(dotType,dot, line,index,color) {  //startX,startY,isStart) {
  
    let thisOverlayLine = db.curLine;    
    dot.addEventListener('mousedown',function (e) {
      let snapEndLine = false;
      let tempPos,startIndex;
      let startX = dot.x;
      let thisLine = line;
      let deleteFlag = false;

      startIndex = findLineSegDotIndex(dot,dotType);
    
      
      let tempLine = null;
     
      dot.addEventListener('pressmove', function (e) {

        // keep adjusting the object x,y throughout drag
        tempPos = db.curProb.container.globalToLocal(stage.mouseX, stage.mouseY);  
        snapEndLine = true;
     
        if (tempLine == null)  {
          tempLine = new createjs.Shape();
        }
        else {
          tempLine.graphics.clear();
        }
        
        tempLine.graphics.beginStroke(color).setStrokeStyle(2);
        tempLine.graphics.moveTo(startX,dot.y).lineTo(tempPos.x,dot.y);
       
        db.curProb.container.addChild(tempLine);

        stage.update();
        dot.x = tempPos.x;
        
      }); 
  
      // create event listener for pressup to end drag/drop and watch for mouse clicks and long clicks
      dot.addEventListener('pressup', function (e) {

        let newIndex = -2;
        let addStart = 0;
        let addEnd = 0;

        if (tempLine != null)  {
          db.curProb.container.removeChild(tempLine);
        }

        if (snapEndLine) {
          
          if (dotType == START_LINESEG_DOT) {
          
            // calculuate to which grid index position dot was moved to, with limit of 0 index
            // adjust -1 for array index vs width size
            newIndex = Math.max(Math.round(dot.x/(db.curProb.gridW)),0);
            // if move start past end of problem, set delete flag and set newindex temporily to end
            if (newIndex > line.sym.length-1) {
              deleteFlag = true;
              newIndex = line.sym.length-1;
            }
            newIndex = Math.min(newIndex,line.sym.length-1);
            dot.x = (newIndex) * db.curProb.gridW; 
            //newIndex--;
            line.sym[index].lineSegStart = null;
            line.sym[newIndex].lineSegStart = dot;

            // if moved start to the right, then remove line segements from symbols no longer in line
            if (newIndex > startIndex) { 
              for (let i = startIndex; i < newIndex; i++) {
             
                db.curProb.container.removeChild(line.sym[i].lineSeg);
                line.sym[i].lineSeg = null;
              }
            }
            // otherwise set up to add more line segments to grid symbols added to line
            else {
              addEnd = startIndex;
              addStart = newIndex;
            }
          }
          else {
            // calculuate the which symbol grid dot was moved to, with limit of 0 index
            newIndex = Math.round(dot.x/(db.curProb.gridW)); 
            if (newIndex <= 0) {
              deleteFlag = true;
              newIndex = 1;
            }
           
            //newIndex = Math.max(newIndex,db.curProb.width-1);
            // if this position is past end of this line, but within problem width, fill line with null symbols
            if (newIndex >= line.sym.length) {
                let tempLine = db.curLine;
                db.curLine = line;
                for (let i = line.sym.length; i < db.curProb.width; i++) {
                  pushOneNullSym();
                }
                db.curLine = tempLine;
            }
           
            newIndex = Math.min(newIndex,line.sym.length);
   
            dot.x = newIndex * db.curProb.gridW; 
            newIndex--;
            line.sym[startIndex].lineSegEnd = null;
            line.sym[newIndex].lineSegEnd = dot;

            if (newIndex < startIndex) { 
              for (let i = startIndex; i > newIndex; i--) {
                db.curProb.container.removeChild(line.sym[i].lineSeg);
                line.sym[i].lineSeg = null;
              }
            }
            // otherwise set up to add more line segments to grid symbols added to line
            else {
              addEnd = newIndex;
              addStart = startIndex;
            }
          }
          // if there's been a change, add anyneeded segments to symbols
          let segDeleted = false;
          if (newIndex > -1) {
            // check if line should be deleted
           
              let endDotIndex,startDotIndex;
             
              if (dotType == START_LINESEG_DOT) {
                endDotIndex = findLineSegDotIndex(dot.matchingDot,END_LINESEG_DOT);
                startDotIndex = newIndex;
              }
              else {
                startDotIndex = findLineSegDotIndex(dot.matchingDot,START_LINESEG_DOT);
                endDotIndex = newIndex;
              }

              // if the endpoints overlap, or delete flag, then delete the line segment
              if ((endDotIndex < startDotIndex) || deleteFlag) {
                // will have one symbol needing line segment removed if deleted flag
                if (deleteFlag) {
                  db.curProb.container.removeChild(line.sym[newIndex].lineSeg);
                  line.sym[newIndex].lineSeg = null;
                }
                segDeleted = true;
                dot.removeAllEventListeners();
                dot.matchingDot.removeAllEventListeners();
                db.curProb.container.removeChild(dot);
                db.curProb.container.removeChild(dot.matchingDot);
                line.sym[endDotIndex].lineSegEnd = null;
                line.sym[startDotIndex].lineSegStart = null;
              }
            
            // draw in any line segments needed in symbols added to line  
            if (!segDeleted && addStart != addEnd) {
              drawOneSetLineSegment(line,dot.y,addStart,addEnd,color);
            }
          }

          // add an undo record for the line change
          if (db.state != STATE_OPEN_FILE) {
              if (db.mProb.length > 0) {
                  db.fileChanged = true;
                  cvGetDataUndoPush();
              }
          }
          

        }
      
        doStageUpdate();
          
        e.target.removeAllEventListeners('pressmove');
        e.target.removeAllEventListeners('pressup');
      });
      
    
    });
    
  
  }



  // SAVE FOR DIVIDES ONLY
  export function drawNewLineSym(startX,endX,keyID,overlay) {

    
    let color = "black";
  
    if (overlay.lineShape != null) {
      overlay.container.removeChild(overlay.lineShape);
    }
    let lineShape = new createjs.Shape();
    overlay.lineShape = lineShape;
    overlay.myProb = db.curProb; // check
    let startY;

    if (overlay.container == null) {
      overlay.container = new createjs.Container();
    }
    else {
      overlay.container.removeAllChildren(); 
    }  

    let lineContainer = overlay.container;

    let startDot;
    lineShape.graphics.beginStroke(color).setStrokeStyle(2);
    if (keyID == symConst.KEY_ID_LINE) { 
      startY = (overlay.lIndex+1)*db.curProb.gridH;
      lineShape.name = OVERLAY_TYPE_LINE;
      lineShape.graphics.moveTo(startX,startY).lineTo(endX,startY);

      
      startDot = new createjs.Shape();
      startDot.name = CREATEJS_NAME_LINE_DOT_START;
      startDot.graphics.beginStroke(color).beginFill("white").drawCircle(0,0,6/stage.scaleX);
      startDot.x = 0; //startX;
      startDot.y = startY;
      //lineContainer.addChild(lineShape,startDot);
      
    }
    else { // must be divide if not line segment
      startY = (overlay.lIndex)*db.curProb.gridH;
      lineShape.name = OVERLAY_TYPE_DIVIDE;
      lineShape.graphics.moveTo(startX,startY+db.curProb.gridH).lineTo(startX,startY).lineTo(endX,startY);
    }
  
    let endDot = new createjs.Shape();
    endDot.name = CREATEJS_NAME_LINE_DOT;
    endDot.graphics.beginStroke(color).beginFill("white").drawCircle(0,0,6/stage.scaleX);
    endDot.x = endX;
    endDot.y = startY;
    lineContainer.addChild(lineShape,endDot);
    
    overlay.container.y = 0;
    db.curProb.container.addChild(lineContainer);
    
    doStageUpdate();
    db.probState = STATE_DRAW_OVERLAY;

    watchLineResize(endDot,overlay,startX,startY);
    //watchLineResize(startDot,overlay,0,startY,true);

    // line only gets a starting scale dot
    //if (keyID == symConst.KEY_ID_LINE) { 
      //watchLineResize(startDot,lineContainer,lineShape,overlay, startX,startY,true);
    //}

    return(lineContainer);
  }


function drawDivOverlayUpdate(overlay) {
 

}

function watchLineResize(dot,overlay, startX,startY,isStart) {
  
  
    let thisOverlayLine = db.curLine;    
    dot.addEventListener('mousedown',function (e) {
      let snapEndLine = false;
      let tempPos;
      let overlayType = overlay.lineShape.name;
     
      dot.addEventListener('pressmove', function (e) {


        startX = overlay.start * db.curProb.gridW;    // changed from db
        if (overlayType == OVERLAY_TYPE_DIVIDE) {
          startY = overlay.lIndex * db.curProb.gridH;
        }
        else { // lines are at the bottom and divide lines at the top of a grid
          startY =(overlay.lIndex+1 )* db.curProb.gridH
          //console.log("watch lIndex",overlay.lIndex);
        }
       
        // keep adjusting the object x,y throughout drag
        
        tempPos = overlay.container.globalToLocal(stage.mouseX, stage.mouseY);
     
        if (tempPos.x > 0) {
          dot.x = tempPos.x;
          dot.y = startY;
          if (overlay.lineShape != null) {
            overlay.container.removeChild(overlay.lineShape);
          }
          overlay.lineShape = new createjs.Shape();
          overlay.lineShape.name = overlayType;
         
             if (overlay.lineShape.name == OVERLAY_TYPE_DIVIDE) {
                overlay.lineShape.graphics.clear().beginStroke("green").setStrokeStyle(2)
                overlay.lineShape.graphics.moveTo(startX,startY+db.curProb.gridH).lineTo(startX,startY).lineTo(tempPos.x,startY);
                }
            else {
                overlay.lineShape.graphics.clear().beginStroke("green").setStrokeStyle(2).moveTo(startX,startY);
                overlay.lineShape.graphics.lineTo(tempPos.x,startY);
               }
         
          overlay.container.y = 0;
          overlay.myProb = db.curProb;
          overlay.container.addChildAt(overlay.lineShape,0);
          snapEndLine = true;
          doStageUpdate();
        }
      }); 
  
      // create event listener for pressup to end drag/drop and watch for mouse clicks and long clicks
      dot.addEventListener('pressup', function (e) {
        // if the user moved the line end point, adjust it to align with the next largeest grid corner
        let gridLengths;
        if (snapEndLine && db.curOverlay != null) {    // changed from db
          if (isStart) {
            if (dot.x < 0) {
              gridLengths  = Math.ceil((dot.x*(-1))/db.curProb.gridW);
              dot.x = -1* (gridLengths * db.curProb.gridW);
              
            }
            overlay.start = gridLengths;   //changed from db
          }
          else {
            // check for a line delete, delete if user moves line to less than a half a grid width
            if (overlay.lineShape.name == OVERLAY_TYPE_LINE && dot.x < db.curProb.gridW/2) {
              overlay.container.removeAllEventListeners();
              overlay.container.removeAllChildren();
              overlay.isActive = false;
              overlay.container = null;
              let findLine = db.curProb.line[overlay.lIndex];
              findLine.overlayLine = null;

            }
            else { 
              gridLengths = Math.ceil((dot.x)/db.curProb.gridW);
              dot.x = gridLengths * db.curProb.gridW;
              overlay.lineShape.graphics.lineTo(dot.x,startY);
              overlay.end = gridLengths;   // changed from db
            }
          }
          doStageUpdate();
        }   
          e.target.removeAllEventListeners('pressmove');
        e.target.removeAllEventListeners('pressup');
      });
      
    
    });
    
  
  }

  export function drawUpdatedOverlay(overlay,stayActive) {
    
    if (stayActive && overlay.isActive) {
      overlay.container.removeAllEventListeners();
      overlay.container.removeAllChildren();
      let type = (overlay.type == OVERLAY_TYPE_DIVIDE) ? symConst.KEY_ID_DIVISION : symConst.KEY_ID_LINE;
      //console.log("line update called",stayActive, overlay.lIndex);
      drawNewLineSym(overlay.start*db.curProb.gridW,
                      overlay.end*db.curProb.gridW,type,overlay);
      stage.update;
    }
    else { 
      stayActive = false;
      overlay.isActive = false;  
      let lineShape;
      let color = (stayActive) ? "green" : "black" ;
     
      // check that container exists, which is be true except during a file open
      if (overlay.container != null) { 
      
        let endDot = overlay.container.getChildByName(CREATEJS_NAME_LINE_DOT);
        if (endDot != null) {
          if (stayActive ) {
            endDot.x = overlay.end * db.curProb.gridW * stage.scaleX;
          }
          else {
            endDot.removeAllEventListeners();
            endDot.visible = false;
          }
        } 
        let startDot = overlay.container.getChildByName(CREATEJS_NAME_LINE_DOT_START);
        if (startDot != null) {
          if (stayActive) {
            startDot.x = overlay.start * db.curProb.gridW * stage.scaleX;
          }
          else {
            startDot.removeAllEventListeners();
            startDot.visible = false;
          }
        } 
        lineShape = overlay.container.getChildByName(overlay.type);
        overlay.container.removeChild(lineShape);
      }
      else { // may not get called? 
          overlay.container = new createjs.Container();
          db.curProb.container.addChild(overlay.container);
        }
    
      lineShape = new createjs.Shape();  
      lineShape.name = overlay.type;
      lineShape.graphics.beginStroke(color).setStrokeStyle(2);
      let overlayProb = overlay.myProb;
      if (overlayProb == null) {
        console.log("ERROR - got null overlay"); 
        return;  // shouldn't ever happen, safety return in case of data structure error
      }
      
      if (overlay.type == OVERLAY_TYPE_LINE) {
        lineShape.graphics.moveTo(overlay.start*overlayProb.gridW, (overlay.lIndex+1) * overlayProb.gridH);
        lineShape.graphics.lineTo(overlay.end*overlayProb.gridW, (overlay.lIndex+1) * overlayProb.gridH);
      }
      else {  // if not a line segment, that means it's a divide symbol
        lineShape.graphics.moveTo(overlay.start*overlayProb.gridW, (overlay.lIndex+1) * overlayProb.gridH);
        lineShape.graphics.lineTo(overlay.start*overlayProb.gridW, (overlay.lIndex) * overlayProb.gridH);
        lineShape.graphics.lineTo(overlay.end*overlayProb.gridW, (overlay.lIndex) * overlayProb.gridH);
      }
      overlay.container.y = 0;  // clear out changes from grid moves, since lIndex was also changed
      overlay.container.addChildAt(lineShape,0);
      doStageUpdate();
      
    // clear db.curOverLay as an indicator of state, used for when users click on other problems during overlay draw
    //if (!stayActive) {
    //  db.curOverlay = null;
    //  db.probState = STATE_NORMAL;
    //}
  
   }
  }
  
 
// function drawEmptyGrid draws a graph-paper like grid fragment for a single math problem
// The grid is drawn extending a half grid size beyond the specified problem, described as 
// a starting X,Y position, and the number of grid units wide and high
export function drawEmptyGrid(startX,startY,widthCount,heightCount,heighOffset) {

  //console.log("start drawEmptyGrid", widthCount);
  if (widthCount == 0) {
    return;
  }
  widthCount = widthCount;

  // if gridline darkness gets changed in user prefs then may need to redraw
  if (db.curProb.gridShape != null) {
    db.curContainer.removeChild(db.curProb.gridShape);
  }

  db.curProb.gridShape = new createjs.Shape();
  db.curProb.gridShape.mouseEnabled = false; 
  let endX; 
  let endY = startY+db.curProb.gridH*heightCount;

  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    db.curProb.gridLineIndex = db.userPrefs.gridLineIndex;
    endX = startX+db.curProb.gridW*widthCount;
    db.curProb.gridShape.graphics.setStrokeStyle(symConst.CV_GRID_LINE_STROKE[db.curProb.gridLineIndex])    //(0.2);
    db.curProb.gridShape.graphics.beginStroke(symConst.CV_GRID_LINE_COLOR[db.curProb.gridLineIndex]);  //PROBLEM_GRID_COLOR)
    // draw horizontal lines

    for (let yIndex = 0; yIndex <= heightCount; yIndex++) {
      db.curProb.gridShape.graphics.moveTo(startX-db.curProb.halfGW,startY+db.curProb.gridH*yIndex);
      db.curProb.gridShape.graphics.lineTo(endX+db.curProb.halfGW,startY+db.curProb.gridH*yIndex);
    }
  
    // draw vertical lines
    for (let xIndex = 0; xIndex <= widthCount; xIndex++) {
      db.curProb.gridShape.graphics.moveTo(startX+db.curProb.gridW*xIndex,startY-db.curProb.halfGW);
      db.curProb.gridShape.graphics.lineTo(startX+db.curProb.gridW*xIndex,endY+db.curProb.halfGW);
    }
  }
  else {    // line type problem, draw box instead
    // add one extra grid space worth of space in line problems to allow for clicking to right of problem
    endX = startX+db.curProb.gridW*(widthCount);
    db.curProb.gridShape.alpha = 0.4;
    db.curProb.gridShape.graphics.beginStroke("black").setStrokeStyle(.5); //PROBLEM_BACKGROUND_COLOR);  
    db.curProb.gridShape.graphics.rect(startX, startY, endX, endY);
    db.curProb.gridShape.x = 0;
    db.curProb.gridShape.y = heighOffset*db.curProb.gridH;
  }
 
  db.curContainer.addChildAt(db.curProb.gridShape,0);  
  doStageUpdate();  
}

// function copySelectTimer is called from a timer set within watchMouseEvents, on clicks of the current problem only
// it is now set for copy/paste selections
export function copySelectTimer(target, isMenuClick) {  // target is the target from the mouse-press event, used in line problems to find the branch
  
 
  if (db.curProb.displayType == DISPLAY_TYPE_TEXT) {
    return;
  }

  if (isMenuClick)  {
    // adjust cursor, as workaround for createjs cursor bug
    let canvas = document.getElementById('drawingboard');
    canvas.classList.remove("default-cursor");
    canvas.classList.add("ew-resize-cursor");
  }
  
    db.state = STATE_IN_CLIPBOARD_SELECT;
    let sIndex; 
    
    if (db.curProb.displayType == DISPLAY_TYPE_GRID) {

      if (!isMenuClick) {                    
        var point = getCorrectXY(db.curProb.container); 
        setInsertPosGrid(point.x,point.y);  
      }
      db.selectionArea = new SelectionAreaType(db.curLine.sIndex,db.curLine.sIndex,db.curProb.gridW, db.curProb.gridH);
      db.selectionArea.parent = db.curProb.container;
      //db.selectionArea.nextSymX = db.curProb.container.x + (db.curLine.sIndex+1)*db.curProb.gridW;
      db.selectionArea.startX = db.curProb.gridW*(db.curLine.sIndex+1);
      db.selectionArea.startY = db.curProb.gridH*db.curProb.lIndex;
      db.selectionArea.probEndX = db.curProb.width*db.curProb.gridW - db.selectionArea.startX; // offset to end of problem
      db.selectionArea.probStartX = -db.selectionArea.startX;
      db.selectionArea.curBranch = db.curLine;
      for (let k = 0; k < db.curLine.sym.length; k++) {
        db.curLine.sym[k].clipOffset = k*db.curProb.gridW-db.selectionArea.startX;
        //console.log(db.curLine.sym[k].str,db.curLine.sym[k].clipOffset);
      }
      //console.log(db.selectionArea.startX ,db.selectionArea.startY);
      drawselectionHighlight(db.selectionArea);
    }            
    
    else if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      if (!isMenuClick) {
        // if it was a click within a line problem then figure out the right position
        // menu clicks will use the current branch position instead
  
        if (target.isBranch) {
          db.curBranch = target.branch;
          var point = getCorrectXY(db.curBranch.container);
          setInsertBranch(point.x, point.y);
        }
      }
          
       
        sIndex = db.curBranch.sIndex;
        let symXStart = tallyLineSymWidths(db.curBranch, db.curBranch.sIndex);
        db.selectionArea = new SelectionAreaType(sIndex,sIndex,db.curProb.gridW, db.curProb.gridH*db.curBranch.bScale);
        db.selectionArea.parent = db.curBranch.container;
        
        //(db.curBranch.parent) ? db.curBranch.parent : db.curLine;
        db.selectionArea.startX = db.curProb.gridW*symXStart;
        calcSymOffsets(db.selectionArea.startX, sIndex);
        //db.selectionArea.startX =(db.curBranch.isBranch) ? db.curProb.gridW*symXStart + db.curBranch.container.x :
        //                                                   db.curProb.gridW*symXStart;
        db.selectionArea.startY = 0; //(db.curBranch.isBranch) ? db.curBranch.container.y : 0;
        let endBranchCount = tallyLineSymWidths(db.curBranch, db.curBranch.sym.length-1);
        db.selectionArea.probStartX = -db.selectionArea.startX;
        db.selectionArea.startBranch = db.selectionArea.curBranch = db.curBranch;
        db.selectionArea.inBranch = db.selectionArea.wasBranch = db.curBranch.isBranch;
        if (db.curBranch.isBranch) {
          db.selectionArea.endBranch = (endBranchCount*db.curProb.gridW) 
                                        - db.selectionArea.startX;
          // hasFirstSym flags whether you can move into a parent branch in a selection - which requires the first symbol
          // in a fraction, exponent, or subscript (since they have no physical symbol to select before that)
          db.selectionArea.hasFirstSym = (sIndex == -1) && 
                                          (db.curBranch.parent.sym[db.curBranch.parentIndex].type == symConst.CV_EXP_SUB_TYPE ||
                                          db.curBranch.parent.sym[db.curBranch.parentIndex].type == symConst.CV_FRACTION_TYPE);  

          db.selectionArea.probEndX =  tallyLineSymWidths(db.curBranch.parent, db.curBranch.parent.sym.length-1)*db.curProb.gridW -
          db.selectionArea.startX-db.curBranch.container.x
          //let parentEndX = tallyLineSymWidths(db.curBranch.parent, db.curBranch.parent.sym.length-1)*db.curProb.gridW -
          //                            db.selectionArea.startX-db.curBranch.container.x;
          //if this branch is nested and parent is another branch, then set calculate next branchs values 
          if (db.curBranch.parent.isBranch) {
            db.selectionArea.probEndX += db.curBranch.parent.container.x;
          }
          
        }
        else {
          db.selectionArea.probEndX = (endBranchCount*db.curProb.gridW) - db.selectionArea.startX; 
        }
        // offset to end of problem
        drawselectionHighlight(db.selectionArea);
      
    }

    // create scaling dot and watch for resizes if this was a menu selection, since user
    // will not be in a mouse drag in that case
    if (isMenuClick) {
      watchSelectClipIconResize();
    }
   
      
}

function watchSelectClipIconResize() {

  // Allow dragging of top or bottom of box
  let resizeDot = new createjs.Shape();
  db.selectionArea.resizeDot = resizeDot;
  resizeDot.graphics.beginStroke("green").setStrokeStyle(3).beginFill("green");
  resizeDot.graphics.drawCircle(0,0,6/stage.scaleX);   

  let resizeDotBackground = new createjs.Shape();
  resizeDotBackground.graphics.beginFill("white");
  resizeDotBackground.graphics.alpha = 0.1;
  resizeDotBackground.visible = false;
  //resizeDotBackground.graphics.drawRect(0,0,50,70);
 
  resizeDotBackground.graphics.drawRect(-db.curProb.gridW/db.curProb.probScale, -db.curProb.gridH*.7/db.curProb.probScale, 
                             db.curProb.gridW*2/db.curProb.probScale, db.curProb.gridH*1.4/db.curProb.probScale )

  resizeDot.x = resizeDotBackground.x = db.selectionArea.width + db.selectionArea.startX;
  resizeDot.y = resizeDotBackground.y = db.selectionArea.height*.5 + db.selectionArea.startY;
  //db.selectionArea.parent.addChild(resizeDotBackground);
  db.selectionArea.parent.addChild(resizeDot);
  stage.update();

 // resizeDotBackground.addEventListener('mousedown',function (e) {
  //  console.log("got rec press")
 // });


  // set listeners to watch for moving resizing dot
  resizeDot.addEventListener("mousedown", function (e) {
 
    let startProbX = db.curProb.container.x;
    let startProbY = db.curProb.container.y;

    resizeDot.addEventListener('pressmove',function (e) {

      let point = getCorrectXY(); // correct in case of iPad
      // setup and call drawSelectionHighlight to constrain area to allowed highlight area
      db.selectionArea.width = (point.x - startProbX - 
                                db.selectionArea.startX); 
     
      if (db.selectionArea.wasBranch) {
       db.selectionArea.width -= db.selectionArea.startBranch.container.x;
      }
      db.selectionArea.width = db.selectionArea.width/db.curProb.probScale;
    
      db.selectionArea.height = (point.y - startProbY - 
                                db.selectionArea.startY)/db.curProb.probScale; 
      drawselectionHighlight(db.selectionArea);

      stage.update();
      
    });
    resizeDot.addEventListener('pressup',function(e) {
    });
  });
   
}


// function watchMouseEvents manages the user mouse interactions that relate to pressing math problem
// boxes.  It is called on the curProb however since it can complete asynchronously then problems pIndexs
// are saved in the name of the createjs object to identify database structures when inner parts of the routine 
// run.   Users actions can include the following - 
// Users may drag/drop any math problem.   
// After the drag is complete, the position of the x,y positions of curProb are updated to reflext 
// Users may click on a problem to select it, which causes the grid to be displayed on those types of problems
// User may do a long mouse press (with timeout) to initiate a scaling box to be drawn

// background passed an be db.curProb.backgroundBox if this is a whole problem background, or
// db.curBranch. branchBackground if this for a branch line in a line problem
function watchMouseEvents(background) {
    //console.log("in watchMouseEvents",db.curProb.backgroundBox);
  
    doStageUpdate();
    let doUndoPush = false;
    // listen for the inital mouse down 
    let isBranch = background.isBranch;
    let isClipboardEvent = false;
    let clickedLine;
    let mouseCounter = 0;

    background.addEventListener('mousedown',function (e) {
    
        //console.log("graphics watch mousedown ", ++mouseCounter,e.target.name);
        //e.preventDefault();
        //e.stopPropagation();
        
        if (db.state == STATE_IN_ABC || db.state == STATE_VIEW_ONLY_FILE) {
          return;
        }
        
        // keep track of the initial positions of the problem and mouse for start of drag
        let startX = stage.mouseX/stage.scaleX;
        let startY = stage.mouseY/stage.scaleY;

        // clear problem, with a flag to only clear the clipboard selection, or regular, not menu clipboard selects
        // or for menu clipboard selects as long as they aren't close to the resize dot -
        if (db.state == STATE_IN_CLIPBOARD_SELECT) {
          if (db.selectionArea.resizeDot == null ||
            e.target.name != db.pIndex ||
            !isClickNearSelectBoxFromMenu(startX, startY)) {
           
            clearProbState(false,true);
          }
          // throw out presses close to a resize Dot, to make it so accidently near clicks don't clear selection box
          else {
            return;
          }
        }
        
        let startProbX = db.mProb[e.target.name].container.x;
        let startProbY = db.mProb[e.target.name].container.y;
        let clickTimer;

        //For mousedown clicks on the current problem, then
        // first check if the scaling box was on, and toggle off if true
        // then set timer for new scaling box
        if (e.target.name == db.pIndex) {         // Pindex is stored in event.name, so can tell by this if at current problem
          if (db.curProb.scalingBox != null) {    // if the scaling box was on will have non-null scaling box
            db.curProb.scalingBox.removeAllEventListeners();
            db.curContainer.removeChild(db.curProb.scalingBox);
            db.curProb.scalingBox = null;
            db.probState = STATE_NORMAL;
            doStageUpdate();
          } 
          clickTimer = setTimeout(copySelectTimer,2000,e.target);  // set timer for new scaling box
        }
        //stage.enableMouseOver(20);    // parameter is number times per second to procast events, max 50
        let tempX, tempY
        // create event listener for pressmove to do drag/drop
        background.addEventListener('pressmove', function (e) {
            
            // clear timeout for scale long click, but not for tiny moves to avoid ipad cancels by acccident finger moves
            tempX = (Math.abs(stage.mouseX/stage.scaleX - startX)); 
            tempY = (Math.abs(stage.mouseY/stage.scaleY- startY));
            if (tempX > 3 || tempY > 3) {
              clearTimeout(clickTimer);
              if (db.state != STATE_IN_CLIPBOARD_SELECT) {
                db.state = STATE_IN_DRAG;
              }
            }

            if (db.state != STATE_IN_CLIPBOARD_SELECT) {
              //db.state = STATE_IN_DRAG;
              db.fileChanged = true;
            // keep adjusting the object x,y throughout drag
             // stage.mouseX and Y do not take account scale, so adjust for any stage scale
             // since drag compares to starting X,Y, don't call getCorrectXY
            db.mProb[e.target.name].container.x = stage.mouseX/stage.scaleX-startX + startProbX; 
            db.mProb[e.target.name].container.y = stage.mouseY/stage.scaleY-startY + startProbY; 
            db.mProb[e.target.name].xpos = db.mProb[e.target.name].container.x + db.mProb[e.target.name].halfGW;
            db.mProb[e.target.name].ypos = db.mProb[e.target.name].container.y + db.mProb[e.target.name].halfGH;
            }
            // if in clipboard select, then don't move problem, instead adjust db.selectionArea
            else {
              
              let point = getCorrectXY(); // correct in case of iPad
              db.selectionArea.width = (point.x - startProbX - 
                                        db.selectionArea.startX); 
             
              if (db.selectionArea.wasBranch) {
               db.selectionArea.width -= db.selectionArea.startBranch.container.x;
              }
              db.selectionArea.width = db.selectionArea.width/db.curProb.probScale;
            
              db.selectionArea.height = (point.y - startProbY - 
                                        db.selectionArea.startY)/db.curProb.probScale; 
              drawselectionHighlight(db.selectionArea);
             

            }
            doStageUpdate();
        })  

        // create event listener for pressup to end drag/drop and watch for mouse clicks and long clicks
        background.addEventListener('pressup', function (e) {

            //console.log("graphics watch pressup", ++mouseCounter,e.target.name);
            //e.preventDefault();
            //e.stopPropagation();

            clearTimeout(clickTimer);    // get rid of long click timer
            // if the pressup happened after a drag, then set the state to normal and skip other processing
            if (db.state == STATE_IN_DRAG) {
              db.state = STATE_NORMAL;
              db.changed = true;
              doUndoPush = true;

              let logInput = new CanvasInput("drag", e.target.name);
              db.userLog.input.push(logInput);
             
              // check for case that just finished dragging the current object
              // if so then reset db x,y positions so they are at the end of this problem
              // WILL NEED TO CHANGE THIS x,y to different when add insert positions
              if(e.target.name == db.pIndex) { 
                db.xpos = db.mProb[e.target.name].xpos + findProbSymX(db.mProb[db.pIndex]);
                db.ypos = db.mProb[e.target.name].ypos + findProbLineY(db.mProb[db.pIndex]);
              }
            }
            // if it wasn't just a drag event, then need to process the pressup
            // first clear the long click timer.  Then figure out if the user clicked
            // on a problem that wasn't current before, in which case change this one to be current
            else {  
                // if this was within a selection for clipboard, deal with that instead 
                if (db.state == STATE_IN_CLIPBOARD_SELECT) {
                 // just leave things as is
               
                }
                else {
                  // clear problem states from prior carry, line, or divide
                  if (db.probState != STATE_NORMAL && db.curProb.scalingBox == null) {
                    clearProbState();
                  }

                  // save some values needed to detect grid fraction clicks on same box
                  let saveSIndex = db.curLine.sIndex;
                  let saveLIndex = db.curProb.lIndex;
                  let newPIndex = false;

                  // if the clicked to select a new problem
                  if (e.target.name != db.pIndex && e.target.name != null) {
                    newPIndex = true;
                      doUndoPush = true;
                      // first turn off the gridshape of the current problem to show it's not longer selected

                      // check that problem clicked off isn't empty, if so then delete this problem
                      // remove it's createjs object and remove problem from db list
                      if (db.curProb.width == 0) {
                        //console.log("delete empty from watcher", db.curProb);
                        deleteEmptyProb(db.curProb);
                      }
                      else {
                        if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
                          db.curProb.fracState = STATE_NORMAL;
                          clearLineSegDots();
                          trimGrid();
                        }
                        hideGridShape(db.curProb);
                        if (db.curProb.scalingBox != null) {    // if the scaling box was selected, clear that out
                          db.curProb.scalingBox.removeAllEventListeners();
                          db.curContainer.removeChild(db.curProb.scalingBox);
                          db.scalingBox = null;
                        } 
                        
                      }
                      

                      // check if in level 3 and just switched from a grid to line problem, or line to grid problem.
                      if (db.mathLevel ==3 && (db.curProb.displayType != db.mProb[e.target.name].displayType)) {
                        if ((db.lev3UseGrid && db.mProb[e.target.name].displayType == DISPLAY_TYPE_LINE) ||
                           (!db.lev3UseGrid && db.mProb[e.target.name].displayType == DISPLAY_TYPE_GRID)) {

                          db.displayType = db.mProb[e.target.name].displayType;
                          db.lev3UseGrid = (db.displayType == DISPLAY_TYPE_GRID) ? true : false;
                          notifySideboardLev3Mode(db.displayType);
                        }
                      }
                      
                      // use the pIndex stored as the target name to make this new problem selected
                      db.curProb = db.mProb[e.target.name];

                      let logInput = new CanvasInput("prob select click", "pIndex" + db.pIndex);
                      db.userLog.input.push(logInput);
                  }
                      
                    
                    // if problem already selected on a grid problem, then set the cursor position to insert here, 
                    // but first check that not just a pressup after a long click scale select, if so adding insert
                    // If in scale then scalingBox won't be null, in which case don't insert 
                  if (db.curProb.scalingBox == null ) { 
                      if (db.curProb.displayType == DISPLAY_TYPE_GRID || db.curProb.displayType == DISPLAY_TYPE_TEXT) {  
                        makeProbSelected(e.target.name);
                      
                        //redraw cursor, moving it from the last problem to this one
                        drawCursor(findProbEndX(db.curProb)+db.curProb.xpos-db.curProb.halfGW, 
                                  findProbEndY(db.curProb)+db.curProb.ypos-db.curProb.halfGH);
                      
                        if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
                            //var point = db.curProb.container.globalToLocal(stage.mouseX, stage.mouseY);
                            var point = getCorrectXY(db.curProb.container); 
                            setInsertPosGrid(point.x,point.y,newPIndex,saveSIndex, saveLIndex);  
                        }            
                      }
                      else if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
                        //console.log(e.target.branchID);
                        // if it was a click within a line problem then figure out the right position
                        //console.log(e.target.branch.isBranch, e.target);
                        if (e.target.isBranch) {   // this .isBranch is different than e.target.branch.isBranch
                          db.curBranch = e.target.branch;
                          var point = getCorrectXY(db.curBranch.container);
                          setInsertBranch(point.x, point.y);
                          makeProbSelectedAt(e.target.name,db.curProb.lIndex,db.curBranch.sIndex);
                    
                          //console.log("here1",db.curProb.lIndex,e.target.isBranch,e.target.name,db.curLine);
                        }
                        // if it was a click on the problem background but not symbol, instead set it to
                        // the last symbol of the line.  If multi-line problem then find line that best
                        // corresponds with mouse click position
                        else {
                         
                          if (db.mProb[e.target.name].line.length > 0) {
                            var point = getCorrectXY(db.mProb[e.target.name].container);
                            clickedLine = findClickedLine(point);
                          }
                          makeProbSelected(e.target.name, clickedLine); 
                        }    
                    
                      }
                  }  
                }
            }
            
        // clean up to clear event listeners 
        if (doUndoPush) {
          doUndoPush = false;
          db.fileChanged = true;
          cvGetDataUndoPush();
        }
        doStageUpdate();
        e.target.removeAllEventListeners('pressmove');
        e.target.removeAllEventListeners('pressup');
        //console.log("graphics watch remove watchers for move and up"); //, db.curProb);
        //stage.enableMouseOver(0);  //  disables mouse over for stage
        });
              
    });
}


function setInsertBranch(newX,newY) {
  if (db.curBranch.isBranch) {
    db.curLine = db.curBranch.myLine;
  }
  else {
    db.curLine = db.curBranch;
  }
  
  db.curProb.lIndex = db.curLine.lineID;
  //console.log(db.curLine,db.curProb.lIndex,db.curLine.lineID);

  let xIndex = newX/(db.curProb.gridW*db.curProb.probScale);
  let thisIndex = findBranchClickIndexRightAdjusted(xIndex);
    //let thisIndex = findBranchClickIndexRightAdjusted(xIndex);
  //console.log(thisIndex,xIndex, db.curBranch);
  db.curBranch.sIndex = thisIndex-1;
  // adjust xpos to be the start of the correct symbol instead of somewhere random where the user clicked
  let xposCount = tallyLineSymWidths(db.curBranch, db.curBranch.sIndex);


  //let temp1 = db.curProb.xpos - db.curProb.halfGW + db.curBranch.container.x;
  //let temp2 = xposCount * db.curProb.gridW * db.curBranch.bScale;

  let temp1 = db.curProb.container.x+ (db.curProb.halfGW) +db.curBranch.container.x;
  let temp2 = xposCount * (db.curProb.gridW/db.curProb.probScale); // bScale already in tallyLine
 
  db.xpos = temp1 + temp2;
  /*
  if (db.curBranch.isBranch) {
    db.ypos = db.curLine.container.y + db.curBranch.container.y + db.curProb.ypos;
  }
  else {
    db.ypos = db.curBranch.container.y + db.curProb.ypos;
  }
  */
 
  resetTreeXYPosAndCursor();
  return(xposCount);

}

function setInsertPosGrid(newX,newY,newPIndex,saveSIndex, saveLIndex) {

 
  // since converted to local coordinates to deal with scaled problems, add back in the current problem location
  newX += db.curProb.container.x;
  newY += db.curProb.container.y;
  
  let offsetX = newX - db.curProb.xpos+db.curProb.halfGW;     // measure distance from click x,y to start of problem
  let offsetY = newY - db.curProb.ypos+db.curProb.halfGH;
  
  let xIndex = Math.trunc(offsetX/db.curProb.gridW);          // figure out how many grid units across this is
  let yIndex = Math.trunc(offsetY/db.curProb.gridH);
  
  db.xpos = xIndex*db.curProb.gridW + db.curProb.xpos;      // set the xpos, ypos to be the midpoint of this unit
  db.ypos = yIndex*db.curProb.gridH + db.curProb.ypos;

  db.curLine = db.curProb.line[yIndex];    
  db.curProb.lIndex = yIndex;

  if (db.curLine.sym == null) {
    console.log("setInsertPos bug ",db.curLine, db.curProb);
   
  }
  
  // check if this line shorter than the click position, add null symbols if so
  if (xIndex > db.curLine.sym.length) {
    for (let k = db.curLine.sym.length; k < xIndex; k++) {
      db.curLine.sIndex = k;
      pushOneNullSym();
    }
  }
  
  //db.curProb.fracState = STATE_NORMAL;
  db.curLine.sIndex = xIndex-1;
  if (!newPIndex && db.curLine.sym[db.curLine.sIndex+1] != null && (db.curLine.sym[db.curLine.sIndex+1].str == symConst.KEY_ID_FRACTION_GRID_SIGN)) {
    if (db.curProb.lIndex == saveLIndex && db.curLine.sIndex == saveSIndex ||
      (db.curProb.fracState != STATE_NORMAL && db.curLine.sIndex == saveSIndex-1)) {
      if (offsetY - yIndex * db.curProb.gridH < (db.curProb.gridH/2)) {
        db.curProb.fracState = STATE_IN_GRID_FRACTION_NUM;
      }
      else {
        db.curProb.fracState = STATE_IN_GRID_FRACTION_DEN;
      }
      db.curLine.sIndex++;
    }
    else {
      db.curProb.fracState = STATE_NORMAL;
    }
  }
  else {
    db.curProb.fracState = STATE_NORMAL;
  }
  
  //console.log(newX,newY,xIndex,yIndex, offsetX, offsetY, db.xpos,db.ypos,db.curProb);
  drawCursor(db.xpos-db.curProb.halfGW,db.ypos-db.curProb.halfGH);
  doStageUpdate();

  let logInput = new CanvasInput("grid click", "x" + xIndex + "y" + yIndex);
  db.userLog.input.push(logInput);
 
  //let boxWidth = (Math.trunc((bounds.width+db.halfGridWidth)/db.gridWidth) * db.gridWidth) + db.gridWidth;

}


  
